let initialized = false;

// Call only after explicit or previously saved cookie consent.
export const initializeYandexMetrika = () => {
  const counterId = 97255592;
  if (typeof window === 'undefined' || initialized) {
    return;
  }

  const hostname = window.location.hostname.toLowerCase();
  if (
    hostname === 'localhost' ||
    hostname.endsWith('.localhost') ||
    /^127\./.test(hostname) ||
    hostname === '[::1]' ||
    hostname === '::1' ||
    hostname === '0.0.0.0'
  ) {
    return;
  }

  initialized = true;
  window.ym = window.ym || function () {
    (window.ym.a = window.ym.a || []).push(arguments);
  };
  window.ym.l = window.ym.l || Date.now();

  const scriptUrl = 'https://mc.yandex.ru/metrika/tag.js';
  if (!Array.from(document.scripts).some(script => script.src === scriptUrl)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptUrl;
    document.head.appendChild(script);
  }

  window.ym(counterId, 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
  });
};
